import { Component, OnInit } from '@angular/core';
import * as $AB from 'jquery';
declare const search:any;
declare const v_search2:any;
declare var Razorpay: any;

@Component({
  selector: 'app-addcart',
  templateUrl: './addcart.component.html',
  styleUrls: ['./addcart.component.css']
})
export class AddcartComponent implements OnInit {

   istype=true;
  isprice=true;
  iscategory=true;
  isclassify=true;
  
  type(){
    this.istype=!this.istype;
  }

  price(){
    this.isprice=!this.isprice;
  }

  category(){
    this.iscategory=!this.iscategory;
  }

  classify(){
    this.isclassify=!this.isclassify;
  }

  razorPayOptions = {
    "key": "rzp_test_Goaqlet7JS58Lt", // Enter the Key ID generated from the Dashboard
    "amount": "100", // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
    "currency": "INR",
    "name": "Datapitcher",
    "description": "Test Transaction",
    "image": "../../../assets/image/sideLogo.png",
     //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
    "handler": function (response){
        alert(response.razorpay_payment_id);
        alert(response.razorpay_order_id);
        alert(response.razorpay_signature)
    },
 
    "notes": {
        "address": "Razorpay Corporate Office"
    },
    "theme": {
        "color": "#8000ff"
    }
};

pay(){
  console.log("a");
var rzp1 = new Razorpay(this.razorPayOptions);

    rzp1.open();
    

}
  constructor() { }

  ngOnInit(): void {
    search();
    v_search2();
    $(".header-title p").text('Add Cart');
  }



  hovercard(){
    $(".inner-div").css('transition', '5.5s all');
   }
    hovercard2(){
      $(".inner-div").css('transition', '0.5s all')
    }

}
